// Currencies a supplier may invoice in (docs/multi-currency-purchasing-plan.md
// D6). A tenant still has one of the 7 SUPPORTED_CURRENCIES; purchase orders,
// vendor bills and supplier payments may be in any of these 21.

export interface PurchaseCurrency {
    code: string; // ISO 4217
    name: string;
    /** Minor-unit decimals: 10 ** decimals minor units per major unit. */
    decimals: 0 | 2 | 3;
}

/** The 7 tenant currencies first, then the 14 the Exchange Rates page offered. */
export const PURCHASE_CURRENCIES: readonly PurchaseCurrency[] = [
    { code: 'INR', name: 'Indian Rupee', decimals: 2 },
    { code: 'AED', name: 'UAE Dirham', decimals: 2 },
    { code: 'SAR', name: 'Saudi Riyal', decimals: 2 },
    { code: 'QAR', name: 'Qatari Riyal', decimals: 2 },
    { code: 'OMR', name: 'Omani Rial', decimals: 3 },
    { code: 'BHD', name: 'Bahraini Dinar', decimals: 3 },
    { code: 'KWD', name: 'Kuwaiti Dinar', decimals: 3 },
    { code: 'USD', name: 'US Dollar', decimals: 2 },
    { code: 'EUR', name: 'Euro', decimals: 2 },
    { code: 'GBP', name: 'British Pound', decimals: 2 },
    { code: 'SGD', name: 'Singapore Dollar', decimals: 2 },
    { code: 'JPY', name: 'Japanese Yen', decimals: 0 },
    { code: 'CNY', name: 'Chinese Yuan', decimals: 2 },
    { code: 'AUD', name: 'Australian Dollar', decimals: 2 },
    { code: 'CAD', name: 'Canadian Dollar', decimals: 2 },
    { code: 'CHF', name: 'Swiss Franc', decimals: 2 },
    { code: 'THB', name: 'Thai Baht', decimals: 2 },
    { code: 'MYR', name: 'Malaysian Ringgit', decimals: 2 },
    { code: 'BDT', name: 'Bangladeshi Taka', decimals: 2 },
    { code: 'LKR', name: 'Sri Lankan Rupee', decimals: 2 },
    { code: 'NPR', name: 'Nepalese Rupee', decimals: 2 },
];

/** Codes of {@link PURCHASE_CURRENCIES}, for validating a currency_code. */
export const PURCHASE_CURRENCY_CODES: readonly string[] = PURCHASE_CURRENCIES.map((c) => c.code);

/**
 * The currency a supplier registered in each country usually invoices in, for
 * the countries whose currency is a purchase currency. Used only to suggest a
 * supplier's currency; the user can change it.
 */
const COUNTRY_PURCHASE_CURRENCY: Readonly<Record<string, string>> = {
    IN: 'INR', AE: 'AED', SA: 'SAR', QA: 'QAR', OM: 'OMR', BH: 'BHD', KW: 'KWD',
    US: 'USD', GB: 'GBP', SG: 'SGD', JP: 'JPY', CN: 'CNY', AU: 'AUD', CA: 'CAD',
    CH: 'CHF', TH: 'THB', MY: 'MYR', BD: 'BDT', LK: 'LKR', NP: 'NPR',
    BE: 'EUR', DE: 'EUR', ES: 'EUR', FR: 'EUR', IE: 'EUR', IT: 'EUR', NL: 'EUR', PT: 'EUR',
};

/** The purchase currency suggested for a supplier in `iso`, or `null` if none fits. */
export function purchaseCurrencyForCountry(iso: string | null | undefined): string | null {
    return iso ? COUNTRY_PURCHASE_CURRENCY[iso] ?? null : null;
}
